import { connect } from "react-redux";
import MobileTabBar from "../MobileTabBar";

export const mapStateToProps = state => {
  return {
    selectedTab: state.selectedTab,
    hasResults: !!Object.keys(state.results).length,
    selectedCount: state.output.length
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTabClick: tab => {
      dispatch({ type: "CHANGE_TAB", tab });
    }
  };
};

// Container Component
const MobileTabBarContainer = connect(mapStateToProps, mapDispatchToProps)(
  MobileTabBar
);

export default MobileTabBarContainer;



// WEBPACK FOOTER //
// ./src/containers/MobileTabBarContainer.js